module.exports = __webpack_public_path__ + "static/media/NotificacionesColfactura.6ecbf057.png";